import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { getEnumLabel } from "../constants/commissionEnums";
import {
  PARTNER_LEVEL_LABELS,
  PARTNER_STATUS_LABELS,
  PARTNER_TYPE_LABELS,
  buildReferralLink,
  buildPartnerJoinLink,
  canShowPartnerJoinLink,
  getPartnerStatusChipColor,
  isPartnerActive,
} from "../constants/partnerEnums";

const Field = ({ label, value }) => (
  <>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ mb: 1.5 }}>
      {value ?? "—"}
    </Typography>
  </>
);

const PartnerDetailsDialog = ({ open, onClose, partner, groupMap, parentMap }) => {
  if (!partner) return null;

  const referralLink = buildReferralLink(partner.referralCode);
  const partnerJoinLink = canShowPartnerJoinLink(partner)
    ? buildPartnerJoinLink(partner.referralCode)
    : "";

  const copyLink = async (text, message) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      toast.success(message);
    } catch {
      toast.error("کپی لینک ناموفق بود.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>جزئیات نماینده #{partner.id}</DialogTitle>
      <DialogContent dividers>
        {!isPartnerActive(partner.status) ? (
          <Alert severity="warning" sx={{ mb: 2 }}>
            این نماینده در وضعیت فعال نیست.
          </Alert>
        ) : null}

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Field label="شناسه کاربر" value={partner.userId} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              وضعیت
            </Typography>
            <Box sx={{ mb: 1.5 }}>
              <Chip
                size="small"
                label={getEnumLabel(PARTNER_STATUS_LABELS, partner.status)}
                color={getPartnerStatusChipColor(partner.status)}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              label="سطح"
              value={getEnumLabel(PARTNER_LEVEL_LABELS, partner.partnerLevel)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              label="نوع"
              value={getEnumLabel(PARTNER_TYPE_LABELS, partner.partnerType)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              label="گروه پورسانتی"
              value={groupMap[partner.commissionGroupId] || partner.commissionGroupId}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field label="کد معرف" value={partner.referralCode} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              label="والد"
              value={
                partner.parentPartnerId
                  ? parentMap[partner.parentPartnerId] || `#${partner.parentPartnerId}`
                  : "—"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              label="اجازه ساخت زیرمجموعه"
              value={partner.canCreateSubPartners ? "بله" : "خیر"}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              label="تاریخ ایجاد"
              value={
                partner.joinedAt
                  ? new Date(partner.joinedAt).toLocaleDateString("fa-IR")
                  : "—"
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary">
              لینک معرف (مشتری)
            </Typography>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 0.5 }}>
              <TextField value={referralLink} fullWidth size="small" InputProps={{ readOnly: true }} />
              <IconButton
                color="primary"
                onClick={() => copyLink(referralLink, "لینک معرف کپی شد.")}
                disabled={!referralLink}
              >
                <ContentCopyIcon />
              </IconButton>
            </Box>
          </Grid>
          {partnerJoinLink ? (
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">
                لینک ثبت‌نام زیرمجموعه
              </Typography>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 0.5 }}>
                <TextField
                  value={partnerJoinLink}
                  fullWidth
                  size="small"
                  InputProps={{ readOnly: true }}
                />
                <IconButton
                  color="primary"
                  onClick={() =>
                    copyLink(partnerJoinLink, "لینک ثبت‌نام زیرمجموعه کپی شد.")
                  }
                >
                  <ContentCopyIcon />
                </IconButton>
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>بستن</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PartnerDetailsDialog;
